/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Vocabulary } from "../Utils/Vocabulary";
import { urlEnum } from "../Utils/UrlEnum";
import MainTable from "../Components/GenericComponents/MainTable";
import { useState } from "react";
import { DeviceModel, ImportExcelDescription } from "../Utils/Models";
import { postData } from "../Services/postData";
import { updateData } from "../Services/updateData";
import { getData } from "../Services/getData";
import Device from "../Components/Devices/Device";
import moment from "moment";
import Config from "../Utils/Config";
import { Button, useMediaQuery } from "@mui/material";
import CloudSyncIcon from "@mui/icons-material/CloudSync";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { toast } from "react-toastify";
import { AxiosResponse } from "axios";
import ImportExcelModal from "../Components/GenericComponents/ImportExcelModal";
import ImportExcelButton from "../Components/GenericComponents/ImportExcelButton";
import SyncWordPressData from "../Components/SyncWordPressData";

export default function Devices() {
  const phoneStyle = useMediaQuery("(max-width: 800px)");
  const [open, setOpen] = useState(false);
  const [openImportExcel, setOpenImportExcel] = useState(false);
  const [editItem, setEditItem] = useState<DeviceModel | null>(null);
  const [shouldUpdate, setShouldUpdate] = useState(false);
  const [syncWp, setSyncWp] = useState(false);

  /**
   *
   */
  const description: Array<ImportExcelDescription> = [
    {
      name: "Name",
      description: Vocabulary.itemName,
      example: "iPhone 13 Pro Max",
    },
    {
      name: "Serial number",
      description: Vocabulary.itemSerialNumber,
      example: "SN1234567890",
    },
    {
      name: "Code",
      description: Vocabulary.itemCode,
      example: "DEV00123",
    },
    {
      name: "Brand",
      description: Vocabulary.itemBrand,
      example: "Apple",
    },
    {
      name: "Model",
      description: Vocabulary.itemModel,
      example: "iPhone 13 Pro Max",
    },
  ];

  /**
   *
   */
  const deviceHeader = [
    { label: Vocabulary.name, name: "name", options: { sort: false } },
    {
      label: Vocabulary.serialNumber,
      name: "serialNumber",
      options: {
        sort: false,
      },
    },

    {
      label: Vocabulary.code,
      name: "code",
      options: {
        sort: false,
      },
    },
    {
      label: Vocabulary.brand,
      name: "brand",
      options: {
        sort: false,
        customBodyRender: (value: any) => {
          return value?.name || "";
        },
      },
    },
    {
      label: Vocabulary.model,
      name: "model",
      options: {
        sort: false,
        customBodyRender: (value: any) => {
          return value?.name || "";
        },
      },
    },
    {
      label: Vocabulary.location || "Location",
      name: "location",
      options: {
        sort: false,
        customBodyRender: (value: any) => {
          return value?.name || "";
        },
      },
    },
  ];
  /**
   *
   * @param item
   */
  function handleEdit(item: DeviceModel | null) {
    setShouldUpdate(false);
    setOpen(!open);
    setEditItem(item);
  }
  /**
   *
   * @param device
   * @param files
   */
  function addOrUpdateDevice(device: DeviceModel, files: any[]) {
    device.purchaseDate = moment(device.purchaseDate).format(
      Config.momentUSDateFormat,
    );

    // Create FormData for file upload
    const formData: any = new FormData();
    if (files && files.length !== 0) {
      files.forEach((file: any) => {
        formData.append("files", file, file.name);
      });
    } else {
      formData.append("files", []);
    }

    // Filter images to only include string paths (already uploaded)
    device.images = device.images.filter((img: any) => typeof img === "string");

    // Prepare device data for backend - convert location object to ID
    const deviceData = {
      ...device,
      location: device.location?._id || null,
    };

    formData.append("device", JSON.stringify(deviceData));

    if (device?._id) {
      updateData(`${urlEnum.devices}/${device._id}`, formData)
        .then((res) => {
          if (res) {
            setOpen(false);
            setShouldUpdate(true);
          }
        })
        .catch((err) => {
          setOpen(false);
        });
    } else {
      postData(urlEnum.devices, formData)
        .then((res: any) => {
          if (res) {
            setOpen(false);
            setShouldUpdate(true);
          }
        })
        .catch((err) => {
          setOpen(false);
        });
    }
  }

  /**
   *
   * @param items
   */
  async function saveToDatabase(items: any) {
    const res = await postData(`${urlEnum.devices}/insertMany`, items);
    if (res && res.data && res.data.result) {
      setOpenImportExcel(false);
      setShouldUpdate(true);
    }
  }

  /**
   * Duplicate a device
   * @param device
   */
  async function handleDuplicate(device: DeviceModel) {
    try {
      // Create a copy of the device without the _id
      const duplicatedDevice = {
        ...device,
        _id: undefined,
        name: `${device.name} (Copy)`,
        serialNumber: `${device.serialNumber || ""}-COPY`,
        createdAt: undefined,
      };

      // Create FormData for the duplicated device
      const formData: any = new FormData();
      formData.append("files", []);

      // Prepare device data for backend - convert location object to ID
      const deviceData = {
        ...duplicatedDevice,
        location: device.location?._id || null,
      };

      formData.append("device", JSON.stringify(deviceData));

      const res = await postData(urlEnum.devices, formData);
      if (res && res.data && res.data.result) {
        toast.success(
          Vocabulary.duplicateSuccess || "Device duplicated successfully",
        );
        setShouldUpdate(true);
      }
    } catch (error) {
      toast.error(`Failed to duplicate device: ${error}`);
    }
  }

  return (
    <div>
      <MainTable
        urlEnumApi={urlEnum.devices}
        header={deviceHeader}
        tableTitle={Vocabulary.devicesList}
        deleteMessages={{
          title: Vocabulary.deleteDevice,
          text: Vocabulary.deleteConfirmationDevice,
        }}
        shouldUpdate={shouldUpdate}
        handleEdit={handleEdit}
        anotherOptionButtons={[
          {
            condition: () => true,
            title: Vocabulary.duplicate || "Duplicate",
            icon: <ContentCopyIcon fontSize="small" />,
            action: (device: DeviceModel) => handleDuplicate(device),
          },
        ]}
        headerButtons={
          <>
            <Button
              onClick={() => {
                setSyncWp(true);
              }}
            >
              <CloudSyncIcon color="primary" />
              <p style={{ fontSize: "12px", color: "rgb(63, 81, 181)" }}>
                {Vocabulary.wordpressSync}
              </p>
            </Button>
            <ImportExcelButton
              onClickImportButton={() => {
                setOpenImportExcel(true);
                setShouldUpdate(false);
              }}
            />
          </>
        }
      />
      {open ? (
        <Device
          editDevice={editItem}
          open={open}
          addOrUpdateDevice={(device, files) =>
            addOrUpdateDevice(device, files)
          }
          onClose={() => handleEdit(null)}
        />
      ) : null}
      {openImportExcel ? (
        <ImportExcelModal
          open={openImportExcel}
          onClose={() => setOpenImportExcel(false)}
          saveItems={(items: any) => saveToDatabase(items)}
          description={description}
        />
      ) : null}
      {syncWp && (
        <SyncWordPressData
          wpUrl={urlEnum.syncWordPressDataDevices}
          open={syncWp}
          onClose={() => {
            setSyncWp(false);
          }}
          onSuccess={() => {
            setShouldUpdate(true);
          }}
        />
      )}
    </div>
  );
}
